import { DeviceService } from './../../services/device.service';
import { Component, OnInit, Input, forwardRef, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PickadateDirective } from './pickadate.directive';

@Component({
    selector: 'gaweb-pick-a-date',
    templateUrl: './pick-a-date.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PickADateComponent),
            multi: true
        }
    ]
})
export class PickADateComponent implements OnInit, ControlValueAccessor, OnChanges {
    @ViewChild(PickadateDirective) pickadateDirective; // First

    @Output() onValueChange: EventEmitter<any> = new EventEmitter();

    private _value: string;
    get value() {
        return this._value;
    }
    @Input()
    set value(val: string) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    @Input() placeholder: string;
    @Input() minDate: Date;
    @Input() isDisabled: boolean;
    @Input() container: string;

    @Input() operatingDays: Array<number>;
    isAndroid: boolean;
    onChange: any = () => { };
    onTouched: any = () => { };

    constructor(private deviceService: DeviceService) { }

    ngOnInit() {
        this.isAndroid = this.deviceService.isAndroidPhone();
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['isDisabled'] && !!changes['isDisabled'].currentValue) {
            if (!!changes['isDisabled'].isFirstChange()) {
                return;
            }
            this.isDisabled = changes['isDisabled'].currentValue;
            if (this.isDisabled) {
                this._value = null;
            }

        }
    }
    valueChange(date) {
        this.value = date;
        this.onValueChange.emit(date);
    }

    showCalendar($event) {
        $event.stopPropagation();
        this.pickadateDirective.openPickaDate();
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }

    writeValue(value) {
        if (value !== null && value !== undefined) {
            this.value = value;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/pick-a-date/pick-a-date.component.ts